import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  bedroomThingsData: [],
  bedroomThingsLoader: true,
  bedroomThingsError: "",
};

const getEndpoint = (roomName) => {
const loc = localStorage.getItem('userLocation');
   const prefix = loc === 'kkt' ? 'kkt' : '';
  // const prefix = localStorage.getItem('userLocation');
  const db = localStorage.getItem('projectDatabase') || '(default)'; // fallback for safety
  // return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}`;
  return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}/${db}`;
};

export const fetchBedroomList = createAsyncThunk(
  'fetchbedroomThings',
  async ({  } = {}, { rejectWithValue }) => {
    try {
      const url = getEndpoint('Bedroom');
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch bedroom data');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const bedroomReducer = createSlice({
  name: 'bedroomThings',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchBedroomList.fulfilled]: (state, action) => {
      state.bedroomThingsData = action.payload;
      state.bedroomThingsLoader = false;
      state.bedroomThingsError = "";
    },
    [fetchBedroomList.pending]: (state) => {
      state.bedroomThingsLoader = true;
      state.bedroomThingsError = "";
    },
    [fetchBedroomList.rejected]: (state, action) => {
      state.bedroomThingsLoader = false;
      state.bedroomThingsError = action.payload ?? "Close the tab and start with new tab";
    },
  },
});

export default bedroomReducer.reducer;